<template>
  <div
    v-show="!hideAlert"
    role="alert"
    class="alert alert-info"
  >
    <button
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Close"
    >
      <span
        aria-hidden="true"
        @click="hideAlert=true"
      >×</span>
    </button>
    <strong>
      {{ $t('search:searchListAlert.noObjectWithSearchConditions') }}<br>
    </strong>
    <div v-dompurify-html="$t('search:searchListAlert.objectWithin15km')" />
  </div>
</template>
<script>
export default {
  name: 'SearchListAlert',
  i18nOptions: { namespaces: 'search' },
  data() {
    return {
      hideAlert: false,
    };
  },
  destroyed() {
    this.$store.coordinatesSearch = false;
  },

};
</script>
